/**
 * Monochrome trust score chip — list/table display (no override UI).
 * Uses --ink* tokens only (fixes legacy purple/gold tier chip styling).
 */

import type { TrustScoreData } from './types'
import { MAX_TRUST_SCORE } from './types'
import { tierDotStyle } from './tierStyles'

interface Props {
  score: TrustScoreData | null
  loading?: boolean
  invited?: boolean
}

export default function TrustScoreChip({ score, loading, invited }: Props) {
  if (invited && !score) {
    return (
      <span className="ts-mini ts-mono">Invited</span>
    )
  }

  if (loading) {
    return (
      <span className="ts-mini ts-mono" style={{ color: 'var(--ink4)' }}>
        …
      </span>
    )
  }

  if (!score) {
    return (
      <span className="ts-mini ts-mono" style={{ color: 'var(--ink5)' }}>
        —
      </span>
    )
  }

  const prefix = score.isOverridden ? '~' : ''
  const dotStyle = tierDotStyle(score.tier)

  return (
    <span className="ts-mini ts-mono">
      {prefix}{score.effectiveScore}/{MAX_TRUST_SCORE}
      <span
        aria-hidden
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          flexShrink: 0,
          display: 'inline-block',
          marginLeft: 4,
          verticalAlign: 'middle',
          ...dotStyle,
        }}
      />
      <span style={{ marginLeft: 6, fontWeight: 600, color: 'var(--ink3)' }}>
        {score.tierLabel}
      </span>
    </span>
  )
}
